import { render, staticRenderFns } from "./DistributorTemplateTypesTab.vue?vue&type=template&id=2ec8ff15&scoped=true"
import script from "./DistributorTemplateTypesTab.vue?vue&type=script&lang=js"
export * from "./DistributorTemplateTypesTab.vue?vue&type=script&lang=js"
import style0 from "./DistributorTemplateTypesTab.vue?vue&type=style&index=0&id=2ec8ff15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8ff15",
  null
  
)

export default component.exports